import { APP_BASE_HREF, CommonModule, CurrencyPipe } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BannerComponent } from '../components/banner/banner.component';
import { MainComponent } from '../components/main/main.component';
import { FavEmptyTileComponent } from '../components/favorites/fav-empty-tile/fav-empty-tile.component';
import { FavTileResultComponent } from '../components/favorites/fav-result/fav-tile-result.component';
import { FavoriteComponent } from '../components/favorites/favorite-tile/favorite-tile.component';
import { InstigatorComponent } from '../components/favorites/instigator-tile/instigator-tile.component';
import { PlaceholderComponent } from '../components/favorites/placeholder-tile/placeholder-tile.component';
import { StateService } from '../services/state.service';
import { VehicleDetailsService } from '../services/vehicle-details.service';
import { DTANFEDMyFavoriteLibComponent } from './dt-an-myfavorite-lib.component';
import { AnToastModule } from '@autonation/dt-an-components-lib/an-toast';
import { TealiumService } from '../services/tealium.service';
import { FormInfoService } from '../services/form-info.service';
import { TooltipComponent } from '../components/common/tooltip/tooltip.component';
import { ModalComponent } from '../components/common/modal/modal.component';
import { CookieModule, CookieService } from 'ngx-cookie';
import {
  AnSubNavComponent,
  AnSubNavModule,
} from '@autonation/dt-an-components-lib/an-sub-nav';
import { NotificationModule } from '@autonation/dt-an-components-lib/notification-modal';

@NgModule({
  declarations: [
    DTANFEDMyFavoriteLibComponent,
    MainComponent,
    FavoriteComponent,
    BannerComponent,
    FavTileResultComponent,
    InstigatorComponent,
    PlaceholderComponent,
    FavEmptyTileComponent,
    TooltipComponent,
    ModalComponent,
  ],
  exports: [DTANFEDMyFavoriteLibComponent],
  imports: [
    CommonModule,
    LazyLoadImageModule,
    AnToastModule,
    CookieModule.withOptions(),
    AnSubNavModule,
    NotificationModule,
  ],
  providers: [
    CurrencyPipe,
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    VehicleDetailsService,
    StateService,
    TealiumService,
    FormInfoService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class DTANFEDMyFavoriteLibModule {}
